import {DI_TOKENS} from '@/di/di.tokens';

import {createInjectionHooks} from 'brandi-react';

const [
  // constants
  useEnvsToken,
  useResourcesToken,
  useGlobalWindowToken,
  useNavigationService,
  useClientRoutesToken,
  // services
  useProjectApiToken,
  useProjectAuthApiToken,
  useErrorsServiceToken,
  useScrollServiceToken,
  useTrackingServiceToken,
  useLoggerServiceToken,
  useLocalStorageServiceToken,
  usePlatformServiceToken,
  useInitializeServiceToken,
  useNavigateServiceToken,
  useNavigationClickerModalServiceToken,
  useDailyGameServiceToken,
  useQueryStringServiceToken,
  useTasksServiceToken,
  useGameOperationsServiceToken,
  useImprovementsServiceToken,
  useLeaderBoardServiceToken,
  useLeaderBoardDevPanelToken,
  useDailyRewardsServiceToken,
  useShareServiceToken,
  useGiftsServiceToken,
  useGiftsDevPanelToken,
  useOnboardingServiceToken,
  useSettingsServiceToken,
  useGameStatusServiceToken,
  useTooltipsServiceToken,
  useGameStatisticsServiceToken,
  useGameStatisticsDevPanelToken,
  useWinnersServiceToken,
  // stores
  useUserStoreToken,
  useTasksStoreToken,
  useLeaderBoardStoreToken,
  useDailyGameStoreToken,
  useConfigToken,
  useNavigationClickerModalStoreToken,
  useClickerStateStoreToken,
  useImprovementsStoreToken,
  useDailyRewardsStoreToken,
  useShareStoreToken,
  useGiftsStoreToken,
  useOnboardingStoreToken,
  useSettingsStoreToken,
  useGameStatusStoreToken,
  useGameStatisticsStoreToken,
  useWinnersStoreToken,
  // clicker game
  useClickerGameAssetsLoader,
  useClickerGameScene,
  useClickerGameResultsSceneToken,
  useGCSEngine,
  useAudioPlayerToken,
  useDevPanelToken,
  useClickerGameEventsToken,
  // utils
  useRealRandomToken,
  usePseudoRandomToken,
  useImprovementsMapServiceToken,
  useRewardsAnimationsServiceToken,
  useMainPageAnimationToken,
  useTooltipsStoreToken,
  useWindowVisibilityServiceToken,
  useVibrationToken,
  useProjectDateToken,
  useConfettiAnimation,
] = createInjectionHooks(
  // constants
  DI_TOKENS.envs,
  DI_TOKENS.resources,
  DI_TOKENS.globalWindow,
  DI_TOKENS.navigationService,
  DI_TOKENS.clientRoutes,
  // services
  DI_TOKENS.projectApi,
  DI_TOKENS.projectUserAuth,
  DI_TOKENS.errorsService,
  DI_TOKENS.scrollService,
  DI_TOKENS.trackingService,
  DI_TOKENS.loggerService,
  DI_TOKENS.localStorageService,
  DI_TOKENS.platformService,
  DI_TOKENS.initializeService,
  DI_TOKENS.navigationService,
  DI_TOKENS.navigationClickerModalService,
  DI_TOKENS.dailyGameService,
  DI_TOKENS.queryStringService,
  DI_TOKENS.tasksService,
  DI_TOKENS.gameOperationsService,
  DI_TOKENS.improvementsService,
  DI_TOKENS.leaderBoardService,
  DI_TOKENS.leaderBoardDevPanel,
  DI_TOKENS.dailyRewardsService,
  DI_TOKENS.shareService,
  DI_TOKENS.giftsService,
  DI_TOKENS.giftsDevPanel,
  DI_TOKENS.onboardingService,
  DI_TOKENS.settingsService,
  DI_TOKENS.gameStatusService,
  DI_TOKENS.tooltipsService,
  DI_TOKENS.gameStatisticsService,
  DI_TOKENS.gameStatisticsDevPanel,
  DI_TOKENS.winnersService,
  // stores
  DI_TOKENS.userStore,
  DI_TOKENS.tasksStore,
  DI_TOKENS.leaderBoardStore,
  DI_TOKENS.dailyGameStore,
  DI_TOKENS.config,
  DI_TOKENS.navigationClickerModalStore,
  DI_TOKENS.clickerStateStore,
  DI_TOKENS.improvementsStore,
  DI_TOKENS.dailyRewardsStore,
  DI_TOKENS.shareStore,
  DI_TOKENS.giftsStore,
  DI_TOKENS.onboardingStore,
  DI_TOKENS.settingsStore,
  DI_TOKENS.gameStatusStore,
  DI_TOKENS.gameStatisticsStore,
  DI_TOKENS.winnersStore,
  // clicker game
  DI_TOKENS.clickerGameAssetsLoader,
  DI_TOKENS.clickerGameScene,
  DI_TOKENS.clickerGameResultsScene,
  DI_TOKENS.gcsEngine,
  DI_TOKENS.clickerGameAudioPlayer,
  DI_TOKENS.devPanelService,
  DI_TOKENS.clickerGameEvents,
  // utils
  DI_TOKENS.realRandom,
  DI_TOKENS.pseudoRandom,
  DI_TOKENS.improvementsMapService,
  DI_TOKENS.rewardsAnimationsService,
  DI_TOKENS.mainPageAnimation,
  DI_TOKENS.tooltipsStore,
  DI_TOKENS.windowVisibilityService,
  DI_TOKENS.vibration,
  DI_TOKENS.projectDate,
  DI_TOKENS.confettiAnimation,
);

export {
  // constants
  useEnvsToken,
  useResourcesToken,
  useGlobalWindowToken,
  useNavigationService,
  useClientRoutesToken,
  // services
  useProjectApiToken,
  useProjectAuthApiToken,
  useErrorsServiceToken,
  useScrollServiceToken,
  useTrackingServiceToken,
  useLoggerServiceToken,
  useLocalStorageServiceToken,
  usePlatformServiceToken,
  useInitializeServiceToken,
  useNavigateServiceToken,
  useNavigationClickerModalServiceToken,
  useDailyGameServiceToken,
  useQueryStringServiceToken,
  useTasksServiceToken,
  useGameOperationsServiceToken,
  useImprovementsServiceToken,
  useLeaderBoardServiceToken,
  useLeaderBoardDevPanelToken,
  useDailyRewardsServiceToken,
  useShareServiceToken,
  useGiftsServiceToken,
  useGiftsDevPanelToken,
  useOnboardingServiceToken,
  useSettingsServiceToken,
  useGameStatusServiceToken,
  useTooltipsServiceToken,
  useGameStatisticsServiceToken,
  useGameStatisticsDevPanelToken,
  useWinnersServiceToken,
  // stores
  useUserStoreToken,
  useTasksStoreToken,
  useLeaderBoardStoreToken,
  useDailyGameStoreToken,
  useConfigToken,
  useNavigationClickerModalStoreToken,
  useClickerStateStoreToken,
  useImprovementsStoreToken,
  useDailyRewardsStoreToken,
  useShareStoreToken,
  useGiftsStoreToken,
  useOnboardingStoreToken,
  useSettingsStoreToken,
  useGameStatusStoreToken,
  useGameStatisticsStoreToken,
  useWinnersStoreToken,
  // clicker game
  useClickerGameAssetsLoader,
  useClickerGameScene,
  useClickerGameResultsSceneToken,
  useGCSEngine,
  useAudioPlayerToken,
  useClickerGameEventsToken,
  // utils
  useRealRandomToken,
  useDevPanelToken,
  usePseudoRandomToken,
  useImprovementsMapServiceToken,
  useRewardsAnimationsServiceToken,
  useMainPageAnimationToken,
  useTooltipsStoreToken,
  useWindowVisibilityServiceToken,
  useVibrationToken,
  useProjectDateToken,
  useConfettiAnimation,
};
